import { type OneDriveFile, type OneDriveFolder } from './types';

class OneDriveFilesCache {
  private readonly cache = new Map<string, (OneDriveFile | OneDriveFolder)[]>();

  has(folderId: string): boolean {
    return this.cache.has(folderId);
  }

  get(folderId: string): (OneDriveFile | OneDriveFolder)[] | null {
    const cachedFiles = this.cache.get(folderId);

    if (typeof cachedFiles === 'undefined') {
      return null;
    }

    return cachedFiles;
  }

  set(folderId: string, files: (OneDriveFile | OneDriveFolder)[]): void {
    this.cache.set(folderId, files);
  }

  reset(): void {
    this.cache.clear();
  }
}

const oneDriveFilesCache = new OneDriveFilesCache();

export default oneDriveFilesCache;
